var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurmissiondeco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 387,
    viewBox: "0 0 212 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 193.5,
    r: 193.5,
    fill: "#FFD096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurmissiondeco2);
export default __webpack_public_path__ + "static/media/ourmissiondeco-2.3d5d7d7e389c2d33d4c04158d6a1dace.svg";
export { ForwardRef as ReactComponent };